import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Container,
  Typography,
  Grid,
  Box,
  Paper,
  Avatar,
} from "@material-ui/core";
import FormatQuoteIcon from "@material-ui/icons/FormatQuote";

const useStyles = makeStyles((theme) => ({
  section: {
    padding: theme.spacing(10, 0),
    backgroundColor: "#ffffff",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(6, 0),
    },
  },
  title: {
    textAlign: "center",
    marginBottom: theme.spacing(6),
    fontWeight: 700,
    fontSize: "2.5rem",
    color: theme.palette.text.primary,
    [theme.breakpoints.down("sm")]: {
      fontSize: "2rem",
      marginBottom: theme.spacing(4),
    },
  },
  testimonialCard: {
    padding: theme.spacing(4),
    height: "100%",
    display: "flex",
    flexDirection: "column",
    borderRadius: 12,
    position: "relative",
    transition: "all 0.3s ease",
    "&:hover": {
      boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
    },
  },
  quoteIcon: {
    position: "absolute",
    top: theme.spacing(2),
    right: theme.spacing(2),
    fontSize: "3rem",
    color: theme.palette.primary.light,
    opacity: 0.3,
  },
  testimonialText: {
    fontSize: "1.1rem",
    lineHeight: 1.7,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(3),
    fontStyle: "italic",
    flex: 1,
  },
  authorSection: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    marginTop: "auto",
  },
  avatar: {
    width: 60,
    height: 60,
    border: `3px solid ${theme.palette.primary.main}`,
  },
  authorInfo: {
    display: "flex",
    flexDirection: "column",
  },
  authorName: {
    fontWeight: 600,
    fontSize: "1.1rem",
    color: theme.palette.text.primary,
  },
  authorRole: {
    fontSize: "0.95rem",
    color: theme.palette.text.secondary,
  },
}));

const TestimonialsSection = ({ title, testimonials = [] }) => {
  const classes = useStyles();

  if (!testimonials || testimonials.length === 0) {
    return null;
  }

  return (
    <Box className={classes.section}>
      <Container>
        <Typography variant="h2" className={classes.title}>
          {title}
        </Typography>
        <Grid container spacing={4}>
          {testimonials.map((testimonial) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={testimonials.length === 2 ? 6 : 4}
              key={testimonial.id}
            >
              <Paper className={classes.testimonialCard} elevation={3}>
                <FormatQuoteIcon className={classes.quoteIcon} />
                <Typography variant="body1" className={classes.testimonialText}>
                  "{testimonial.text}"
                </Typography>
                <div className={classes.authorSection}>
                  <Avatar
                    src={testimonial.photo}
                    alt={testimonial.name}
                    className={classes.avatar}
                  />
                  <div className={classes.authorInfo}>
                    <Typography className={classes.authorName}>
                      {testimonial.name}
                    </Typography>
                    <Typography className={classes.authorRole}>
                      {testimonial.position || testimonial.role}
                    </Typography>
                  </div>
                </div>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default TestimonialsSection;
